import { render, staticRenderFns } from "./UserBalance.vue?vue&type=template&id=c45c0ff4&scoped=true"
import script from "./UserBalance.vue?vue&type=script&lang=js"
export * from "./UserBalance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c45c0ff4",
  null
  
)

export default component.exports